import React from "react";
import {
  FaCalendarAlt,
  FaMoon,
  FaUserTimes,
  FaUsers,
  FaWallet,
} from "react-icons/fa";

const calcStay = (inDate, outDate) =>
  Math.ceil((new Date(outDate) - new Date(inDate)) / (1000 * 60 * 60 * 24));

const StatCard = ({ icon: Icon, iconBg, iconColor, value, label }) => (
  <div
    style={{
      background: "#ffffff",
      border: "1px solid #e9ecef",
      borderRadius: "12px",
      padding: "16px 18px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      minWidth: 0,
    }}
  >
    <div
      style={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        background: iconBg,
        color: iconColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontSize: 20,
      }}
    >
      <Icon />
    </div>
    <div style={{ minWidth: 0 }}>
      <div
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: "#212529",
          lineHeight: 1.2,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </div>
      <div
        style={{
          marginTop: 4,
          fontSize: 13,
          color: "#6c757d",
          fontWeight: 500,
        }}
      >
        {label}
      </div>
    </div>
  </div>
);

const ReservationStats = ({ reservations }) => {
  const activeReservations = reservations.filter(
    (r) =>
      r.reservationType !== "Cancelled" &&
      r.reservationType !== "Cancelled (hide)" &&
      r.reservationType !== "No-show" &&
      r.reservationType !== "Unconfirmed Reservation"
  );

  const totalReservations = activeReservations.length;

  const totalNights = activeReservations.reduce(
    (total, r) => total + calcStay(r.checkIn, r.checkOut),
    0
  );

  const cancelled = reservations.filter(
    (r) =>
      r.reservationType === "Cancelled" ||
      r.reservationType === "Cancelled (hide)" ||
      r.reservationType === "No-show"
  ).length;

  const otherServices = activeReservations.reduce((sum, r) => {
    return sum + Number(r.otherServicesPrice || 0);
  }, 0);

  const totalRevenue = activeReservations.reduce((sum, r) => {
    return sum + Number(r.totalPrice + r.taxes || r.totalRateWithTax || 0);
  }, 0);

  const cards = [
    {
      icon: FaCalendarAlt,
      iconBg: "#e8f8ef",
      iconColor: "#28a745",
      value: totalReservations,
      label: "Reservations",
    },
    {
      icon: FaMoon,
      iconBg: "#e8f1ff",
      iconColor: "#3b82f6",
      value: totalNights,
      label: "Total Nights",
    },
    {
      icon: FaUserTimes,
      iconBg: "#fff3e8",
      iconColor: "#f59e0b",
      value: cancelled,
      label: "Cancelled",
    },
    // {
    //   icon: FaUsers,
    //   iconBg: "#f3e8ff",
    //   iconColor: "#8b5cf6",
    //   value: `PKR ${otherServices.toLocaleString()}`,
    //   label: "Other Services",
    // },
    {
      icon: FaWallet,
      iconBg: "#e6f7f4",
      iconColor: "#0d9488",
      value: `PKR ${totalRevenue.toLocaleString()}`,
      label: "Total Revenue",
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "12px",
      }}
    >
      {cards.map((card) => (
        <StatCard key={card.label} {...card} />
      ))}
    </div>
  );
};

export default ReservationStats;
